import { t } from 'i18next';

export const STEPS = [
  {
    title: t('PizzaCreation:base'),
    showTitleInButton: false
  },
  {
    title: t('PizzaCreation:half1'),
    showTitleInButton: false
  },
  {
    title: t('PizzaCreation:half2'),
    showTitleInButton: false
  }
];

export const MAX_INGREDIENTS = 10;

export const PROCESS_TITLE = 'pizzaByHalves';
